import Vue from 'vue'
import Vuex from 'vuex'
import crypto from 'crypto'

Vue.use(Vuex)

const store = new Vuex.Store({
  state: {
    // 单词表
    newWords: "",
    gaokaoWords: "",
    filterResult: [],
    filterResultMeta: { mode: 'normal', query: '' },
    synonymResult: [],
    // 首字母
    initialValue: "",
    initialSelected: [],
    // 教材模块
    textbookValue: '',
    textbookSelected: [],
    checkedTextbookSave: true,
    // 加载words圈圈
    tagShowWords: false,
    loadingWords: false,

    tagShow3500: false,
    loadingWords3500: false,
    showFade: false,
    // 用户验证
    Authorization: localStorage.getItem('Authorization3500') ? localStorage.getItem('Authorization3500') : '',
    userShow: '未登录',
    // pc or mobile
    route_flag: '',
  },
  mutations: {
    changeLogin (state, token) {
      localStorage.setItem('Authorization3500', token);
    },

  },
  actions: {
  },
  modules: {
  }
})
export default store
